import { Column } from '../../../report/models/column.model';

export class RowResult {
    Id : string;
    Page : number;
    AmountPage : number;
    Columns: Array<Column>;
    IsGroup : boolean;
    IsDetail : boolean;
    Index : number;
    Data: any;
    Total : number;

    Rows : Array<RowResult> = [];
}
